import {useMemo} from 'react'
import {MenuItem} from './MenuItem'
import {DefautlConfigHeader, IMenu} from '../../core/_menu-config'
import {useAuth} from '../../../../../app/modules/auth'
import IUserService from 'src/app/services/user/service'

interface CheckGuardProtectionParams {
  guards?: string[]
  guardBidang?: string[]
  guardSubBidang?: string[]
}

/**
 * This configuration for Nav bar Header Menu
 * you can set menu visible for role
 * like admin, operator, kasubbid, kabid, kecamatan, kelurahan, notaris, umum
 */
export function MenuInner() {
  const {auth} = useAuth()

  const checkGuardProtection = ({
    guardBidang,
    guardSubBidang,
    guards,
  }: CheckGuardProtectionParams): boolean => {
    if (!guards) return true
    const role = auth.user.role
    const roleAllowed = guards.includes(role)

    if (!roleAllowed) return false

    // Sub-bidang filter hanya dipaksa untuk operator
    if (
      role === IUserService.OPERATOR &&
      guardSubBidang?.length &&
      auth.user.nama_sub_bidang
    ) {
      return guardSubBidang.includes(auth.user.nama_sub_bidang.toLowerCase())
    }

    if (guardBidang?.length && auth.user.nama_bidang) {
      return guardBidang.includes(auth.user.nama_bidang.toLowerCase())
    }

    return true
  }

  const visibleMenus = useMemo(() => {
    const seen = new Set<string>()

    return DefautlConfigHeader.filter((data: IMenu) =>
      checkGuardProtection({
        guards: data.guards,
        guardBidang: data.guardBidang,
        guardSubBidang: data.guardSubBidang,
      })
    ).filter((data: IMenu) => {
      const key = `${data.title ?? ''}|${data.link ?? ''}`
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.user?.role, auth?.user?.nama_bidang, auth?.user?.nama_sub_bidang])

  return (
    <>
      {visibleMenus.map((data) => (
        <MenuItem
          key={`${data.title}-${data.link}`}
          title={data.title!}
          to={data.link!}
        />
      ))}
    </>
  )
}
